
import { defineComponent } from 'vue';

// Components
import LoginCard from 'client/components/LoginCard.vue';
import LogoIcon from 'client/components/LogoIcon.vue';

// Utils
import routerService from 'client/services/routerService';

// Store
import { mapStores } from 'pinia';
import UserLoginStore from 'client/stores/UserLoginStore';

interface HelpdeskConfigItem {
  primary: string;
  secondary: string;
  setAsHeader?: boolean;
}

export default defineComponent({
  name: 'HelpdeskInfo',

  components: {
    LoginCard,
    LogoIcon,
  },

  data() {
    return {
      helpdeskHeading: 'Helpdesk contact information',
      backToLoginText: 'Back',
      subheadingText: 'If you\'re having trouble logging in',
      tableHeaderLeft: 'If you work for',
      tableHeaderRight: 'Primary Helpdesk',
    };
  },

  computed: {
    ...mapStores(UserLoginStore),

    emailSubmitResult(): any {
      return this.userLoginStore.emailSubmitResult;
    },

    helpdeskContactInfo(): any {
      const emailResult = this.emailSubmitResult;
      return emailResult?.helpdeskContactInfo;
    },

    logoUrl(): string {
      if (this.helpdeskContactInfo?.include_logo && this.helpdeskContactInfo?.logo_url) {
        return this.helpdeskContactInfo.logo_url;
      }
      return '';
    },

    helpdeskConfig(): HelpdeskConfigItem[] {
      const config = this.helpdeskContactInfo?.config || [];
      // Sort to ensure header row (setAsHeader: true) is always first
      return [...config].sort((a, b) => {
        if (a.setAsHeader) return -1;
        if (b.setAsHeader) return 1;
        return 0;
      });
    },

    hasHelpdeskInfo(): boolean {
      return !!(this.helpdeskContactInfo?.config && this.helpdeskContactInfo.config.length > 0);
    },

    hasUserEmail(): boolean {
      return !!(this.userLoginStore.email && this.userLoginStore.email.length > 0);
    },
  },

  mounted() {
    // Redirect to login if no helpdesk info
    if (!this.hasHelpdeskInfo) {
      routerService.goToUserLogin();
    }
  },

  methods: {
    goBackToLogin() {
      // Navigate back to password step
      // Email is already in the store, no need to pass it in URL
      routerService.goToUserLogin({ query: { step: 'password' } });
    },
  },
});
